import { render, staticRenderFns } from "./TradableBonusTab.vue?vue&type=template&id=525b8b9d&scoped=true"
import script from "./TradableBonusTab.vue?vue&type=script&lang=js"
export * from "./TradableBonusTab.vue?vue&type=script&lang=js"
import style0 from "./TradableBonusTab.vue?vue&type=style&index=0&id=525b8b9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b8b9d",
  null
  
)

export default component.exports